module.exports = "https://static.wanderu.com/ui-react/_next/static/media/logo.79064255.png";